// extracted by mini-css-extract-plugin
export default {"image":"WaitingModal_image__taBYA","title":"WaitingModal_title__Q3K85","content":"WaitingModal_content__V9zqY"};